import { useMutation, useQueryClient } from "react-query";

import { updateEmployeeExpectations } from "~/pages/Editor/EditorStaff/requests/UpdateEmployeeExpectations/getDataExpectations";

export default function useUpdateEmployeeExpectations() {
  const queryClient = useQueryClient();

  return useMutation(updateEmployeeExpectations, {
    onSuccess: () => {
      queryClient.invalidateQueries(["getDataStaffBonus"]);
    },
  });
}
